export default __webpack_public_path__ + "static/media/ic_gmx_30.fbf98602.svg";